/* eslint "react-hooks/exhaustive-deps": "off" */
import React, { useState, useEffect, memo, useRef } from "react";
import { useTranslation } from "react-i18next";
import Graph from "@components/graphStatistics/Pie/Graphs";
import { customTooltips } from "@helpers/_functions";

export default memo(function Index({ employeesPerPosts }) {
  const { t } = useTranslation("pages.employés.statistics");
  const chartRef = useRef(null);
  const [graphData, setGraphData] = useState({});

  useEffect(() => {
    let postsData = {};
    if (employeesPerPosts?.length) {
      postsData = {
        datasets: [
          {
            data: employeesPerPosts?.map((item) => item?.count) || [],
            backgroundColor:
              employeesPerPosts?.map((item) => item?.backgroundColor) || [],
            hoverOffset: 4
          }
        ],
        labels: employeesPerPosts.map(({name, count, percentValue }) => `${name} : ${count} (${percentValue}%)`) || [],
      };
    }
    setGraphData(postsData);
  }, [employeesPerPosts]);

  const translatedLegends = employeesPerPosts
    ?.map(({ name, backgroundColor }) => ({
      name: t(name),
      backgroundColor
    }))

  const customOptions = {
    tooltips: {
      enabled:false,
      custom: (tooltip)=>customTooltips(tooltip,chartRef,t),
    },
  };
  return (
    <Graph
      graphData={graphData}
      legends={translatedLegends}
      title={t("Répartition par poste")}
      spaceLegende="arh-space-y-2"
      customOptions={customOptions}
      chartRef={chartRef} 
    />
  );
});
